module.exports = __webpack_public_path__ + "img/icon-events-orange.5d42a371.svg";